// // src/context/AuthContext.js
// import React, { createContext, useState } from 'react';
// import axios from 'axios';
// export const AuthContext = createContext();
// export function AuthProvider({ children }) {
//   const [user, setUser] = useState(null);
//   const login = async (username, password, channel) => {
//     try {
//       const response = await axios.post(
//         'http://localhost:8000/auth/login',
//         {
//           username,
//           password,
//           channel, // Include the channel
//         },
//         { withCredentials: true } // Include cookies
//       );
//       setUser({ username, channel }); // Store user info including channel
//     } catch (err) {
//       throw err;
//     }
//   };
//   const logout = async () => {
//     try {
//       await axios.get('http://localhost:8000/auth/logout', { withCredentials: true });
//       setUser(null);
//     } catch (err) {
//       console.error('Error during logout:', err);
//     }
//   };
//   return (
//     <AuthContext.Provider value={{ user, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// }



// src/context/AuthContext.js with the forntend ntid and pass with channel flip
import React, { createContext, useState } from 'react';
export const AuthContext = createContext();
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const logout = async () => {
    try {
      const res = await fetch('http://localhost:8000/liva/auth/logout', {
        credentials: 'include'
      });
      if (res.ok) {
        setUser(null);
      }
    } catch (err) {
      console.error('Error during logout:', err);
    }
  };
  return (
    <AuthContext.Provider value={{ user, setUser, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}
